import { OnlyContentTypes } from 'govbr.frontend.policy/helpers/BlockConditions';
import { defineMessages } from 'react-intl';

import PersonEdit from './PersonEdit';
import PersonDataView from './PersonView';
import { personSchema } from './schema';

import iconSVG from '@plone/volto/icons/user.svg';

defineMessages({
  personData: {
    id: 'Person',
    defaultMessage: 'Person',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.personDataBlock = {
    id: 'personDataBlock',
    title: 'Person',
    group: 'organization',
    icon: iconSVG,
    view: PersonDataView,
    edit: PersonEdit,
    blockSchema: personSchema,
    mostUsed: true,
    restricted: OnlyContentTypes(['Pessoa']),
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
